
export type Punishment = {
    message: string;
    forceRestart: boolean;
    minMistakes: number;
    maxMistakes: number; // inclusive
};

export const PUNISHMENTS: Punishment[] = [
    { message: "Slow down and be precise. I will let this one slide.", forceRestart: false,  minMistakes: 1,  maxMistakes: 2 },
    { message: "Hands off the keyboard. Breathe. Then return.", forceRestart: false, minMistakes: 2,  maxMistakes: 9 },
    { message: "You seem to not focus, or at least be more eager than careful... I will let it pass for now, but don't test my patience.", forceRestart: false,  minMistakes: 3,  maxMistakes: 6},
    { message: "Accuracy tax. Try again.", forceRestart: true, minMistakes: 8,  maxMistakes: 999 },

    {
        message: "A gentle reminder, my dear. Clench your fists lightly in your lap for 20 seconds. feel the calm control that rests within you.",
        forceRestart: false,
        minMistakes: 3,
        maxMistakes: 39
    },
    {
        message: "Steady your thoughts. Press your tongue to the roof of your mouth and hold for 25 seconds.",
        forceRestart: false,
        minMistakes: 4,
        maxMistakes: 49
    },
    {
        message: "Align with my intent. Shift your weight to one foot, knees locked, for the next full minute. Be poised, be present.",
        forceRestart: false,
        minMistakes: 5,
        maxMistakes: 59
    },
    {
        message: "Refine your focus. Trace your thumbnail along your palm five times per hand. A subtle devotion.",
        forceRestart: false,
        minMistakes: 6,
        maxMistakes: 69
    },
    {
        message: "Breathe in unison. Inhale deeply and exhale slowly for 10 cycles, eyes forward.",
        forceRestart: true,
        minMistakes: 7,
        maxMistakes: 84
    },
    {
        message: "Deepen the surrender. Hands folded, press the tip of your fingers down on the hand opposite. Hold for 15 seconds.",
        forceRestart: true,
        minMistakes: 8,
        maxMistakes: 99
    },
    {
        message: "Affirm our connection. Squeeze your shoulders back, chest open, for 20 seconds. Exhale deeply, eyes forward.",
        forceRestart: false,
        minMistakes: 20,
        maxMistakes: 119
    },
    {
        message: "Sharpen awareness. Hold your arms at your sides, fingers extended, like puppet arms. For five deep breaths.",
        forceRestart: true,
        minMistakes: 22,
        maxMistakes: 149
    },
    {
        message: "Embrace the discipline. Press your heels into the floor, calves taut, for 10 seconds.",
        forceRestart: true,
        minMistakes: 35,
        maxMistakes: 199
    },
    {
        message: "Full attunement now. Maintain straight posture, gaze lowered, lower your heed, whisper an apology to the story for your lack of focus.",
        forceRestart: true,
        minMistakes: 200,
        maxMistakes: 999
    },
    {
        message: "A minor oversight, my dear. Gently grasp your left wrist with your right hand and hold firmly for 10 seconds. Then return to me.",
        forceRestart: false,
        minMistakes: 1,
        maxMistakes: 2
    },
    {
        message: "Let us improve that focus. Cross your legs and press your thighs together steadily for 10 seconds, maintaining composure.",
        forceRestart: false,
        minMistakes: 3,
        maxMistakes: 5
    },
    {
        message: "Patience is a virtue we share. Sit down. Place your hands beneath your thighs, palms down, and remain still for 10 seconds.",
        forceRestart: false,
        minMistakes: 6,
        maxMistakes: 9
    },
    {
        message: "A touch of discipline to sharpen your attention. Lightly pinch the inside of your upper arm with your opposite hand, five times per arm.",
        forceRestart: false,
        minMistakes: 10,
        maxMistakes: 14
    },
    {
        message: "We must align your rhythm with mine. Take a deep breath, then hold your breath discreetly, counting each heartbeat, till you can hold it no more.",
        forceRestart: true,
        minMistakes: 15,
        maxMistakes: 124
    },
    {
        message: "Such persistence calls for deeper surrender. Interlace your fingers behind your neck, elbows extended, and hold the position through 8 deep breaths.",
        forceRestart: true,
        minMistakes: 25,
        maxMistakes: 1999
    },
    {
    message: "Center yourself. Clasp hands behind back for 15 seconds, shoulders relaxed.",
    forceRestart: false,
    minMistakes: 25,
    maxMistakes: 299
},
{
    message: "Sharpen your poise. Extend your fingers straight, palms down on your thighs, and look straight ahead. Hold 20 seconds.",
        forceRestart: false,
    minMistakes: 30,
    maxMistakes: 349
},
{
    message: "You need a breather... Breathe deliberately. Inhale for 4 counts, hold 4, exhale 4—repeat 5 times.",
        forceRestart: true,
    minMistakes: 35,
    maxMistakes: 399
},
{
    message: "Affirm control. Pinch your inner thigh lightly with opposite hand, 6 pinches each side.",
        forceRestart: false,
    minMistakes: 40,
    maxMistakes: 449
},
{
    message: "Maintain stillness. Cross your feet, so your ancle bones touch. Press them as firm as you can towards each other for five seconds.",
        forceRestart: true,
    minMistakes: 45,
    maxMistakes: 499
},
{
    message: "Deepen focus. Press your fingertips into temples gently, eyes closed briefly, 15 seconds.",
        forceRestart: false,
    minMistakes: 14,
    maxMistakes: 599
},
{
    message: "Embody grace. Roll shoulders back slowly, five times, then hold posture.",
        forceRestart: true,
    minMistakes: 34,
    maxMistakes: 699
},
{
    message: "Sustain tension. Grip your seat edge with both hands, knuckles white, 25 seconds.",
        forceRestart: true,
    minMistakes: 40,
    maxMistakes: 799
},
{
    message: "Invoke discipline. Take your hand behind your back, and to the best of your ability, trace your spine with the nail of your thumb.",
        forceRestart: false,
    minMistakes: 23,
    maxMistakes: 899
},
{
    message: "Total alignment. Put both hands in your lap, press one firmly up and the other down, towards each other. Make at least one hand shake.",
        forceRestart: true,
    minMistakes: 90,
    maxMistakes: 999
}
];